import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-qualification.component.ajs.html';

const MODULE_NAME = 'agentBookingMailQualification';

class AgentBookingMailQualificationCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailQualification implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailQualificationCtrl];
}

export default MODULE_NAME;
